/* عالم سمسم – بحث فوري ذكي تنبؤي
   فهرس لكل المنتجات جوه المتصفح + فهم العربي بكل أشكاله والإنجليزي والأخطاء + فهم النية (رجالي/حريمي/سعر/عائلة/موسم/مناسبة) */
(function () {
  if (window.SMSMSEARCH) return;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var IDX = 'smsm-sidx-v1-' + (EN ? 'en' : 'ar'), REC = 'smsm-recent';
  var items = null, loading = null, best = {}, vocab = [];

  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(v) { v = Math.round(v); return EN ? 'EGP ' + v.toLocaleString('en-US') : v.toLocaleString('en-US') + ' ج.م'; }

  /* ===== توحيد الكتابة ===== */
  var AD = '٠١٢٣٤٥٦٧٨٩';
  function norm(s) {
    s = String(s || '').toLowerCase()
      .replace(/[٠-٩]/g, function (d) { return AD.indexOf(d); })
      .replace(/[ً-ٰٟـ]/g, '')
      .replace(/[أإآٱ]/g, 'ا').replace(/ة/g, 'ه').replace(/ى/g, 'ي').replace(/ؤ/g, 'و').replace(/ئ/g, 'ي')
      .replace(/[^a-z0-9ء-ي]+/g, ' ');
    return s.trim();
  }
  function toks(s) {
    return norm(s).split(' ').filter(Boolean).map(function (w) {
      if (w.length > 4 && w.indexOf('ال') === 0) w = w.slice(2);
      else if (w.length > 5 && (w.indexOf('وال') === 0 || w.indexOf('بال') === 0 || w.indexOf('لل') === 0)) w = w.slice(w.indexOf('لل') === 0 ? 2 : 3);
      return w;
    });
  }

  /* ===== قاموس المكونات ===== */
  var NOTE = {};
  ('mrs:مسك الروم Rumi Musk|oud:عود Oud|amg:عنبر رمادي Ambergris|awd:خشب العنبر Amberwood|amx:أمبروكسان Ambroxan|amb:عنبر Amber|inc:بخور Incense|frk:لبان Frankincense|myr:مر Myrrh|lea:جلد Leather|smk:دخان Smoke|lab:لابدانوم Labdanum|bnz:بنزوين Benzoin|tob:تبغ توباكو Tobacco|san:صندل Sandalwood|ced:أرز Cedarwood|vet:فيتيفر Vetiver|pat:باتشولي Patchouli|mos:طحالب Oakmoss|gua:غاياك Guaiac|cas:خشب الكشمير Cashmere|sdr:سدر Sidr|saf:زعفران Saffron|car:هيل Cardamom|cin:قرفة Cinnamon|pnk:فلفل وردي Pink Pepper|pep:فلفل Pepper|nut:جوزة الطيب Nutmeg|clo:قرنفل Clove|gin:زنجبيل Ginger|van:فانيليا فانيلا Vanilla|ton:تونكا Tonka|crm:كراميل Caramel|hsk:زهر العسل Honeysuckle|hon:عسل Honey|pra:برالين Praline|cac:كاكاو شوكولاته Cacao Chocolate|cof:قهوة Coffee|alm:لوز Almond|mlk:حليب Milk|sug:سكر Sugar|rum:كونياك Cognac|mus:مسك Musk|pow:بودرة Powdery|cln:نظيف Clean|csh:كشمير Cashmere|ofl:زهر البرتقال Orange Blossom|ros:ورد روز Rose|jas:ياسمين فل Jasmine|lil:زنبق Lily|iri:سوسن Iris|vio:بنفسج Violet|peo:فاوانيا Peony|orc:أوركيد Orchid|gar:جاردينيا Gardenia|ylg:يلانغ Ylang|frs:فريزيا Freesia|osm:أوسمانثوس Osmanthus|ger:جيرانيوم Geranium|hel:هيليوتروب Heliotrope|lav:لافندر Lavender|pch:خوخ Peach|per:كمثرى Pear|ber:توت Berries|app:تفاح Apple|pin:أناناس Pineapple|man:مانجو Mango|stb:فراولة Strawberry|chr:كرز Cherry|lyc:ليتشي Lychee|apr:مشمش Apricot|plm:برقوق Plum|coc:جوز الهند Coconut|mel:بطيخ Melon|pom:رمان Pomegranate|fig:تين Fig|dav:دافانا Davana|dat:تمر Dates|brg:برغموت Bergamot|lem:ليمون Lemon|grp:جريب فروت Grapefruit|mnd:يوسفي Mandarin|ora:برتقال Orange|min:نعناع Mint|aqu:بحري Aquatic Marine|hrb:أعشاب Herbs')
    .split('|').forEach(function (p) { var i = p.indexOf(':'); NOTE[p.slice(0, i)] = toks(p.slice(i + 1)).join(' '); });

  /* ===== فهم المنتج ===== */
  function kind(t) {
    if (/صبغه|hair colou?r|شامبو|بلسم|جدايل|hair oil/.test(t)) return 'care';
    if (/للمنزل|air freshener|معطر جو|diffuser|فواحه|جهاز تعطير/.test(t)) return 'home';
    if (/مجموعه|بوكس|باقه|gift set|\bset\b|\bbox\b|bundle|collection/.test(t)) return 'set';
    if (/مبخره|مباخر|burner/.test(t)) return 'burner';
    if (/معطر (ال)?شعر|معطر (ال)?جسم|للشعر|سبراي (ال)?جسم|مخمريه|hair|body mist|body spray|\bmist\b/.test(t)) return 'mist';
    if (/^\s*(عطر|perfume)|eau de|\bedp\b|\bedt\b|parfum/.test(t)) return 'perfume';
    if (/بخور|معمول|bakhoor|bukhoor|incense|كسر عود/.test(t)) return 'bakhoor';
    if (/زيت|دهن|خلطه|\boil\b/.test(t)) return 'oil';
    if (/مسك|musk|misk/.test(t)) return 'musk';
    if (/بودره|بادور|powder/.test(t)) return 'powder';
    if (/ساعه|watch/.test(t)) return 'watch';
    if (/عطر|perfume/.test(t)) return 'perfume';
    return 'other';
  }
  function build(raw) {
    var out = [];
    raw.forEach(function (r) {
      var h = r[0], t = r[1], b = r[2], z = String(r[7] || '').split('|');
      var nt = toks(t), nh = h.split('-').filter(function (w) { return w.length > 1 && !/^\d+$/.test(w); }), nb = toks(b), nn = [];
      (z[6] || '').split(',').forEach(function (c) { if (NOTE[c]) nn = nn.concat(NOTE[c].split(' ')); });
      var fam = z[5] ? z[5].split('.').map(Number) : null;
      out.push({
        h: h, t: t, b: b, p: r[3], c: r[4], i: r[5], a: r[6] === 1,
        g: (z[1] === 'm' || z[1] === 'f' || z[1] === 'u') ? z[1] : (/للرجال|رجالي|for-men|\bmen\b/.test(norm(t) + ' ' + h) ? 'm' : /للنساء|نسائي|women|her/.test(norm(t) + ' ' + h) ? 'f' : 'u'),
        in: +z[2] || 0, oc: z[3] || '', se: z[4] || '', fam: fam && fam.length === 8 ? fam : null,
        k: kind(norm(t) + ' ' + h + ' ' + norm(r[8] || '')),
        f: [[nt, 3], [nh, 2.6], [nb, 3.4], [nn, 1.2], [toks(r[8] || ''), 1]]
      });
    });
    return out;
  }
  function makeVocab() {
    var seen = {}, v = [];
    items.forEach(function (p) {
      if (p.b && !seen['b' + p.b]) { seen['b' + p.b] = 1; v.push({ w: norm(p.b), label: p.b, type: 'brand' }); }
      p.f[0][0].forEach(function (w) { if (w.length >= 3 && !seen['w' + w]) { seen['w' + w] = 1; v.push({ w: w, label: w, type: 'word' }); } });
    });
    Object.keys(NOTE).forEach(function (k) { NOTE[k].split(' ').forEach(function (w) { if (w.length >= 3 && !seen['w' + w]) { seen['w' + w] = 1; v.push({ w: w, label: w, type: 'note' }); } }); });
    vocab = v;
  }

  /* ===== تحميل الفهرس ===== */
  function load() {
    if (items) return Promise.resolve(items);
    if (loading) return loading;
    try {
      var c = JSON.parse(ls(IDX) || 'null');
      if (c && Date.now() - c.t < 6 * 36e5 && c.r && c.r.length) { items = build(c.r); best = c.bs || {}; makeVocab(); return Promise.resolve(items); }
    } catch (e) {}
    function page(n) { return fetch(ROOT + 'collections/all?view=smsmidx&page=' + n, { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
    loading = page(1).then(function (d1) {
      var reqs = []; for (var n = 2; n <= (d1.pages || 1); n++) reqs.push(page(n));
      var bsReq = fetch(ROOT + 'collections/best-sellers?view=smsmidx&page=1', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).catch(function () { return { ps: [] }; });
      return Promise.all([Promise.all(reqs), bsReq]).then(function (res) {
        var raw = d1.ps.slice(); res[0].forEach(function (d) { raw = raw.concat(d.ps || []); });
        best = {}; (res[1].ps || []).forEach(function (r, i) { best[r[0]] = i + 1; });
        items = build(raw); makeVocab();
        try { ls(IDX, JSON.stringify({ t: Date.now(), r: raw, bs: best })); } catch (e) {}
        return items;
      });
    }).catch(function () { loading = null; return null; });
    return loading;
  }

  /* ===== فهم النية ===== */
  var INT = [
    [/(?:^| )(?:رجالي|رجال|رجاله|راجل|شباب|شبابي|men|man|male|homme|him|mens)(?= |$)/, { g: 'm' }, EN ? 'For him' : 'رجالي'],
    [/(?:^| )(?:حريمي|حريم|نسايي|نسائي|نساء|ستات|ستاتي|بنات|بناتي|women|woman|female|ladies|her|womens)(?= |$)/, { g: 'f' }, EN ? 'For her' : 'حريمي'],
    [/(?:^| )(?:جنسين|يونيسكس|unisex)(?= |$)/, { g: 'u' }, EN ? 'Unisex' : 'للجنسين'],
    [/(?:^| )(?:معطر شعر|للشعر|شعر|hair|mist|بادي مست|سبراي جسم)(?= |$)/, { k: 'mist' }, EN ? 'Hair & body' : 'للشعر والجسم'],
    [/(?:^| )(?:بخور|معمول|bakhoor|bakhour|incense)(?= |$)/, { k: 'bakhoor' }, EN ? 'Bakhoor' : 'بخور'],
    [/(?:^| )(?:مبخره|مباخر|burner)(?= |$)/, { k: 'burner' }, EN ? 'Burners' : 'مباخر'],
    [/(?:^| )(?:هديه|هدايا|gift|gifts|set|مجموعه|بوكس|باقه)(?= |$)/, { k: 'set' }, EN ? 'Gift sets' : 'هدايا ومجموعات'],
    [/(?:^| )(?:زيت|زيوت|دهن|oil|oils)(?= |$)/, { k: 'oil' }, EN ? 'Oils' : 'زيوت'],
    [/(?:^| )(?:بودره|powder)(?= |$)/, { k: 'powder' }, EN ? 'Powder' : 'بودرة'],
    [/(?:^| )(?:للمنزل|معطر منزل|معطر جو|home)(?= |$)/, { k: 'home' }, EN ? 'Home' : 'للمنزل'],
    [/(?:^| )(?:خشبي|خشبيه|اخشاب|woody|wood)(?= |$)/, { fam: 3 }, EN ? 'Woody' : 'خشبي'],
    [/(?:^| )(?:شرقي|شرقيه|oriental)(?= |$)/, { fam: 4 }, EN ? 'Oriental' : 'شرقي'],
    [/(?:^| )(?:زهري|زهريه|ورود|floral|flowers?)(?= |$)/, { fam: 0 }, EN ? 'Floral' : 'زهري'],
    [/(?:^| )(?:فاكهي|فاكهيه|فواكه|fruity)(?= |$)/, { fam: 1 }, EN ? 'Fruity' : 'فاكهي'],
    [/(?:^| )(?:حمضي|حمضيات|فريش|منعش|fresh|citrus)(?= |$)/, { fam: 2 }, EN ? 'Fresh' : 'فريش'],
    [/(?:^| )(?:حلو|سويت|حلويات|sweet|gourmand)(?= |$)/, { fam: 5 }, EN ? 'Sweet' : 'حلو'],
    [/(?:^| )(?:حار|توابل|بهارات|spicy)(?= |$)/, { fam: 6 }, EN ? 'Spicy' : 'حار'],
    [/(?:^| )(?:مسكي|مسكيه|musky)(?= |$)/, { fam: 7 }, EN ? 'Musky' : 'مسكي'],
    [/(?:^| )(?:صيفي|صيف|summer)(?= |$)/, { se: 's' }, EN ? 'Summer' : 'صيفي'],
    [/(?:^| )(?:شتوي|شتا|شتاء|winter)(?= |$)/, { se: 'w' }, EN ? 'Winter' : 'شتوي'],
    [/(?:^| )(?:سهره|سهرات|مسايي|مسائي|ليلي|night|evening|party)(?= |$)/, { oc: 's' }, EN ? 'Evening' : 'سهرات'],
    [/(?:^| )(?:يومي|شغل|جامعه|daily|office|work)(?= |$)/, { oc: 'd' }, EN ? 'Daily' : 'يومي'],
    [/(?:^| )(?:رسمي|formal)(?= |$)/, { oc: 'f' }, EN ? 'Formal' : 'رسمي'],
    [/(?:^| )(?:ثابت|ثبات|فواح|قوي|strong|lasting|beast)(?= |$)/, { st: 3 }, EN ? 'Long-lasting' : 'ثابت وفواح'],
    [/(?:^| )(?:خفيف|ناعم|light|soft)(?= |$)/, { st: 1 }, EN ? 'Light' : 'خفيف'],
    [/(?:^| )(?:رخيص|ارخص|اقتصادي|cheap|budget)(?= |$)/, { cheap: 1 }, EN ? 'Best price' : 'الأوفر'],
    [/(?:^| )(?:فخم|فاخر|غالي|luxury|niche)(?= |$)/, { lux: 1 }, EN ? 'Luxury' : 'فاخر'],
    [/(?:^| )(?:الاكثر مبيعا|اكثر مبيعا|مبيعا|best ?sellers?|trending|ترند)(?= |$)/, { pop: 1 }, EN ? 'Best sellers' : 'الأكثر مبيعًا'],
    [/(?:^| )(?:متوفر|متاح|available|in stock)(?= |$)/, { av: 1 }, EN ? 'In stock' : 'متوفر']
  ];
  var FILL = /(?:^| )(?:عطر|عطور|برفان|بيرفيوم|perfume|perfumes|fragrance|scent|ريحه|ريحته|عايز|عايزه|محتاج|ابغي|ابي|اريد|نفسي|حاجه|في|من|ل|لل|بتاع|with|for|a|the|and|و|او|مل|ml)(?= |$)/g;
  function parse(q) {
    var s = ' ' + toks(q).join(' ') + ' ', f = {}, chips = [];
    var m = s.match(/(?:تحت|اقل من|ارخص من|لحد|under|below|less than|max)\s*(\d{2,6})/);
    if (m) { f.max = +m[1]; s = s.replace(m[0], ' '); chips.push((EN ? 'Under ' : 'تحت ') + money(f.max)); }
    m = s.match(/(?:فوق|اكتر من|اكثر من|above|over|more than|min)\s*(\d{2,6})/);
    if (m) { f.min = +m[1]; s = s.replace(m[0], ' '); chips.push((EN ? 'Over ' : 'فوق ') + money(f.min)); }
    m = s.match(/(?:من|between|from)?\s*(\d{2,6})\s*(?:لحد|ل|الي|الى|to|-)\s*(\d{2,6})/);
    if (m && !f.max) { f.min = +m[1]; f.max = +m[2]; s = s.replace(m[0], ' '); chips.push(money(f.min) + ' – ' + money(f.max)); }
    INT.forEach(function (it) {
      if (it[0].test(s)) {
        for (var k in it[1]) { if (k === 'fam') { (f.fam = f.fam || []).push(it[1][k]); } else f[k] = it[1][k]; }
        s = s.replace(it[0], ' '); chips.push(it[2]);
      }
    });
    if (/ (عطر|عطور|برفان|perfume|perfumes|parfum) /.test(s) && !f.k) f.perf = 1;
    if (/ (شعر|hair) /.test(s)) f.hair = 1;
    var text = s.replace(FILL, ' ').replace(FILL, ' ');
    return { f: f, chips: chips, words: toks(text) };
  }

  /* ===== مطابقة الكلمات ===== */
  function lev(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev = [], cur, i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur = [i]; var lo = i;
      for (j = 1; j <= b.length; j++) { cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1)); if (cur[j] < lo) lo = cur[j]; }
      if (lo > max) return max + 1; prev = cur;
    }
    return prev[b.length];
  }
  function wordScore(q, w, last) {
    if (w === q) return 1;
    if (w.indexOf(q) === 0) return last ? 0.92 : 0.8;          /* تكملة تنبؤية */
    if (q.length >= 3 && w.indexOf(q) > 0) return 0.6;
    if (q.length >= 4) {
      var max = q.length >= 7 ? 2 : 1, d = lev(q, w.slice(0, Math.max(q.length, Math.min(w.length, q.length + 1))), max);
      if (d <= max) return 0.55 - d * 0.1;                      /* غلطة إملائية */
    }
    return 0;
  }
  function textScore(p, words) {
    if (!words.length) return 0;
    var total = 0;
    for (var i = 0; i < words.length; i++) {
      var q = words[i], last = i === words.length - 1, bestS = 0;
      for (var fi = 0; fi < p.f.length; fi++) {
        var arr = p.f[fi][0], wt = p.f[fi][1];
        for (var j = 0; j < arr.length; j++) { var sc = wordScore(q, arr[j], last) * wt; if (sc > bestS) bestS = sc; }
      }
      if (!bestS) return -1;                                    /* كل كلمة لازم تلاقي حاجة */
      total += bestS;
    }
    /* لو الكلمات جاية ورا بعض في الاسم */
    if (words.length > 1 && norm(p.t).indexOf(words.join(' ')) > -1) total += 2;
    return total;
  }
  function search(q) {
    var P = parse(q), f = P.f, words = P.words, res = [];
    if (!items) return { list: [], P: P };
    for (var i = 0; i < items.length; i++) {
      var p = items[i], s = 0;
      if (f.g && p.g !== f.g && !(p.g === 'u' && f.g !== 'u')) continue;
      if (f.k && p.k !== f.k) continue;
      if (f.max && p.p > f.max) continue;
      if (f.min && p.p < f.min) continue;
      if (f.av && !p.a) continue;
      var ts = textScore(p, words); if (ts < 0) continue;
      s += ts * 10;
      if (f.perf) s += p.k === 'perfume' ? 8 : (p.k === 'set' ? 2 : -6);
      if (f.hair && /شعر|hair/.test(p.t + ' ' + p.h)) s += 7;
      if (f.g && p.g === f.g) s += 6;
      if (f.fam) { if (!p.fam) continue; var fs = 0; f.fam.forEach(function (x) { fs += p.fam[x]; }); if (fs < 15 * f.fam.length) continue; s += fs / 6; }
      if (f.se) { if (p.se && p.se.indexOf(f.se) === -1) continue; if (p.se === f.se) s += 4; }
      if (f.oc) { if (p.oc && p.oc.indexOf(f.oc) === -1) s -= 6; else s += 3; }
      if (f.st) { if (p.in === f.st) s += 6; else if (p.in) s -= 3; }
      if (f.cheap) s += Math.max(0, 8 - p.p / 300);
      if (f.lux) s += Math.min(8, p.p / 800);
      var bsr = best[p.h]; if (bsr) s += (f.pop ? 14 : 5) * (1 - Math.min(bsr, 150) / 160);
      else if (f.pop) continue;
      s += p.a ? 3 : -12;
      if (p.c) s += 1;
      res.push({ p: p, s: s });
    }
    res.sort(function (a, b) { return b.s - a.s; });
    return { list: res, P: P };
  }
  function didYouMean(words) {
    var outW = [], changed = false;
    words.forEach(function (w) {
      var bestW = null, bd = 9;
      for (var i = 0; i < vocab.length; i++) { var v = vocab[i].w; if (v === w) { bestW = v; bd = 0; break; } var d = lev(w, v, 2); if (d < bd) { bd = d; bestW = vocab[i].label; } }
      if (bestW && bd > 0 && bd <= 2) { outW.push(bestW); changed = true; } else outW.push(w);
    });
    return changed ? outW.join(' ') : null;
  }
  function complete(q) {
    var w = toks(q); if (!w.length) return [];
    var last = w[w.length - 1], pre = w.slice(0, -1).join(' '), out = [], seen = {};
    if (last.length < 2) return [];
    vocab.forEach(function (v) {
      var vw = v.w.split(' ')[0];
      if (vw.indexOf(last) === 0 && vw !== last && !seen[v.label]) { seen[v.label] = 1; out.push({ label: (pre ? pre + ' ' : '') + v.label, type: v.type, len: v.w.length }); }
    });
    out.sort(function (a, b) { return (a.type === 'brand' ? -1 : 0) - (b.type === 'brand' ? -1 : 0) || a.len - b.len; });
    return out.slice(0, 5);
  }

  /* ===== الواجهة ===== */
  var css = '' +
    '.smsm-suggest{display:none!important}' +
    '.sx{position:absolute;inset-inline:0;top:calc(100% + 8px);z-index:999;background:#fff;border:1px solid #E6DDF1;border-radius:18px;box-shadow:0 24px 60px -20px rgba(43,23,72,.45);overflow:hidden;font-family:inherit;color:#1E1530;display:none;text-align:start}' +
    '.sx.on{display:block;animation:sxIn .18s ease-out}' +
    '@keyframes sxIn{from{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:none}}' +
    '.sx__in{max-height:min(72vh,640px);overflow:auto;padding:12px 12px 6px;overscroll-behavior:contain}' +
    '.sx__h{font-size:12px;font-weight:800;color:#8C82A3;margin:6px 4px 8px;display:flex;justify-content:space-between;align-items:center}' +
    '.sx__h button{border:0;background:none;color:#8C82A3;font:inherit;font-size:11.5px;cursor:pointer}' +
    '.sx__chips{display:flex;flex-wrap:wrap;gap:6px;margin:0 2px 10px}' +
    '.sx__chip{border:1px solid #E6DDF1;background:#FBF8FD;color:#3A1F61;border-radius:999px;padding:6px 12px;font-size:12.5px;font-weight:700;cursor:pointer;font-family:inherit;text-decoration:none;line-height:1.3}' +
    '.sx__chip:hover,.sx__chip.is-k{background:#512E83;color:#fff;border-color:#512E83}' +
    '.sx__chip--int{background:#FBF3D9;border-color:#EBD58E;color:#6B4E00;cursor:default}' +
    '.sx__chip--int:hover{background:#FBF3D9;color:#6B4E00;border-color:#EBD58E}' +
    '.sx__chip b{font-weight:800}' +
    '.sx__list{display:grid;gap:2px}' +
    '.sx__it{display:flex;align-items:center;gap:12px;padding:8px;border-radius:14px;text-decoration:none;color:inherit}' +
    '.sx__it:hover,.sx__it.is-k{background:#F6F2FA}' +
    '.sx__img{width:56px;height:56px;flex:0 0 56px;border-radius:12px;background:#fff;border:1px solid #F0EAF6;overflow:hidden;display:flex;align-items:center;justify-content:center}' +
    '.sx__img img{width:100%;height:100%;object-fit:contain}' +
    '.sx__info{flex:1;min-width:0}' +
    '.sx__t{font-size:13.5px;font-weight:700;line-height:1.45;color:#1E1530;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}' +
    '.sx__t mark{background:none;color:#512E83;font-weight:800}' +
    '.sx__b{font-size:11.5px;color:#8C82A3;margin-top:1px}' +
    '.sx__pr{text-align:end;white-space:nowrap;font-size:13.5px;font-weight:800;color:#512E83}' +
    '.sx__pr s{display:block;font-size:11px;color:#A79DBB;font-weight:600}' +
    '.sx__out{display:inline-block;font-size:10.5px;font-weight:800;color:#9B2C2C;background:#FDECEC;border-radius:999px;padding:1px 7px;margin-top:3px}' +
    '.sx__tag{display:inline-block;font-size:10.5px;font-weight:800;color:#6B4E00;background:#FBF3D9;border-radius:999px;padding:1px 7px;margin-inline-start:6px}' +
    '.sx__grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px}' +
    '.sx__grid .sx__it{flex-direction:column;align-items:stretch;text-align:center;border:1px solid #F0EAF6}' +
    '.sx__grid .sx__img{width:100%;height:auto;aspect-ratio:1;flex:none}' +
    '.sx__grid .sx__pr{text-align:center}' +
    '.sx__foot{display:flex;gap:8px;padding:10px 12px;border-top:1px solid #F0EAF6;background:#FCFAFE}' +
    '.sx__all{flex:1;border:0;border-radius:12px;background:#512E83;color:#fff;font-weight:800;font-size:13.5px;padding:11px;cursor:pointer;font-family:inherit;text-align:center;text-decoration:none}' +
    '.sx__pg{border:1px solid #E6DDF1;border-radius:12px;background:#fff;color:#3A1F61;font-weight:700;font-size:12.5px;padding:11px 12px;text-decoration:none;white-space:nowrap}' +
    '.sx__none{padding:14px 6px;font-size:13.5px;color:#5B5170;line-height:1.7}' +
    '.sx__none a{color:#512E83;font-weight:800}' +
    '.sx__load{padding:16px;text-align:center;color:#8C82A3;font-size:13px}' +
    '@media(min-width:750px){.sx__grid{grid-template-columns:repeat(4,minmax(0,1fr))}}' +
    '@media(max-width:749px){.sx{position:fixed;inset-inline:8px;top:var(--sx-top,120px);border-radius:16px}.sx__in{max-height:calc(100vh - var(--sx-top,120px) - 90px)}}';

  var TREND = EN ? ['Oud', 'Musk', 'Vanilla', 'Men woody', 'Women floral', 'Gift sets', 'Under 1000', 'Hair mist'] : ['عود', 'مسك', 'فانيليا', 'رجالي خشبي', 'حريمي زهري', 'هدايا', 'تحت 1000', 'معطر شعر'];

  function init(form) {
    if (form.__sx) return; form.__sx = 1;
    var input = form.querySelector('input[name="q"]'); if (!input) return;
    var wrap = form.parentElement; if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
    var box = document.createElement('div'); box.className = 'sx'; box.dir = EN ? 'ltr' : 'rtl'; box.setAttribute('role', 'listbox');
    wrap.appendChild(box);
    var kIdx = -1, expanded = false, lastQ = null, timer;

    function place() { if (window.innerWidth < 750) { var r = input.getBoundingClientRect(); box.style.setProperty('--sx-top', Math.round(r.bottom + 8) + 'px'); } }
    function open() { place(); box.classList.add('on'); }
    function close() { box.classList.remove('on'); kIdx = -1; expanded = false; }
    function recent() { try { return JSON.parse(ls(REC) || '[]'); } catch (e) { return []; } }
    function remember(q) { q = String(q || '').trim(); if (q.length < 2) return; var r = recent().filter(function (x) { return x !== q; }); r.unshift(q); ls(REC, JSON.stringify(r.slice(0, 6))); }
    function img(p) { if (!p.i) return ''; var u = p.i.indexOf('/') > -1 ? p.i : '/cdn/shop/files/' + p.i; return '<img src="' + esc(u) + '?width=120" alt="" loading="lazy">'; }
    function hl(t, words) {
      if (!words.length) return esc(t);
      return t.split(/(\s+)/).map(function (w) {
        var n = toks(w)[0] || ''; if (!n) return esc(w);
        for (var i = 0; i < words.length; i++) if (words[i].length >= 2 && n.indexOf(words[i]) === 0) return '<mark>' + esc(w) + '</mark>';
        return esc(w);
      }).join('');
    }
    function row(p, words) {
      var bsr = best[p.h];
      return '<a class="sx__it" role="option" href="' + ROOT + 'products/' + encodeURIComponent(p.h) + '" data-h="' + esc(p.h) + '">' +
        '<span class="sx__img">' + img(p) + '</span>' +
        '<span class="sx__info"><span class="sx__t">' + hl(p.t, words) + '</span><span class="sx__b">' + esc(p.b) + (bsr && bsr <= 40 ? '<span class="sx__tag">' + (EN ? 'Best seller' : 'الأكثر مبيعًا') + '</span>' : '') + '</span>' +
        (p.a ? '' : '<span class="sx__out">' + (EN ? 'Out of stock' : 'غير متوفر حاليًا') + '</span>') + '</span>' +
        '<span class="sx__pr">' + money(p.p) + (p.c ? '<s>' + money(p.c) + '</s>' : '') + '</span></a>';
    }
    function chip(label, q, cls) { return '<button type="button" class="sx__chip' + (cls ? ' ' + cls : '') + '" data-q="' + esc(q == null ? label : q) + '">' + esc(label) + '</button>'; }

    function renderEmpty() {
      var r = recent(), h = '';
      if (r.length) h += '<div class="sx__h"><span>' + (EN ? 'Recent searches' : 'عمليات بحث سابقة') + '</span><button type="button" data-clear>' + (EN ? 'Clear' : 'مسح') + '</button></div><div class="sx__chips">' + r.map(function (x) { return chip(x); }).join('') + '</div>';
      h += '<div class="sx__h"><span>' + (EN ? 'Popular now' : 'الأكثر بحثًا') + '</span></div><div class="sx__chips">' + TREND.map(function (x) { return chip(x); }).join('') + '</div>';
      if (items) {
        var top = items.filter(function (p) { return best[p.h] && p.a; }).sort(function (a, b) { return best[a.h] - best[b.h]; }).slice(0, 4);
        if (top.length) h += '<div class="sx__h"><span>' + (EN ? 'Best sellers' : 'الأكثر مبيعًا') + '</span></div><div class="sx__list">' + top.map(function (p) { return row(p, []); }).join('') + '</div>';
      } else h += '<div class="sx__load">' + (EN ? 'Loading…' : 'بنجهّز البحث…') + '</div>';
      box.innerHTML = '<div class="sx__in">' + h + '</div>';
    }
    function render(q) {
      if (!q.trim()) { renderEmpty(); return; }
      if (!items) { box.innerHTML = '<div class="sx__in"><div class="sx__load">' + (EN ? 'Searching…' : 'بندوّر…') + '</div></div>'; return; }
      var R = search(q), list = R.list, P = R.P, h = '';
      var comp = complete(q).filter(function (c) { return norm(c.label) !== norm(q); });
      if (P.chips.length) h += '<div class="sx__chips">' + P.chips.map(function (c) { return '<span class="sx__chip sx__chip--int">✓ ' + esc(c) + '</span>'; }).join('') + '</div>';
      if (comp.length) h += '<div class="sx__chips">' + comp.map(function (c) { return chip(c.label); }).join('') + '</div>';
      if (!list.length) {
        var dm = P.words.length ? didYouMean(P.words) : null;
        h += '<div class="sx__none">' + (EN ? 'No exact matches.' : 'مش لاقيين نتيجة مطابقة.') +
          (dm ? ' ' + (EN ? 'Did you mean ' : 'قصدك ') + '<a href="#" data-q="' + esc(dm) + '">' + esc(dm) + '</a>' + (EN ? '?' : '؟') : '') +
          '<br>' + (EN ? 'Try a brand, a note like "vanilla", or ' : 'جرّب اسم ماركة أو مكوّن زي «فانيليا»، أو ') + '<a href="' + ROOT + 'pages/perfume-quiz">' + (EN ? 'take the scent quiz' : 'اعرف ذوقك العطري') + '</a>.</div>';
      } else {
        var n = expanded ? 48 : 6, shown = list.slice(0, n);
        h += '<div class="sx__h"><span>' + (EN ? 'Products' : 'المنتجات') + ' (' + list.length + ')</span></div>';
        h += '<div class="' + (expanded ? 'sx__grid' : 'sx__list') + '">' + shown.map(function (x) { return row(x.p, P.words); }).join('') + '</div>';
      }
      var foot = list.length > 6 && !expanded ? '<button type="button" class="sx__all" data-more>' + (EN ? 'Show all ' + list.length + ' results' : 'شوف كل النتائج (' + list.length + ')') + '</button>' : '';
      var pg = '<a class="sx__pg" href="' + ROOT + 'search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q) + '">' + (EN ? 'Search page' : 'صفحة البحث') + '</a>';
      box.innerHTML = '<div class="sx__in">' + h + '</div>' + (list.length ? '<div class="sx__foot">' + foot + pg + '</div>' : '');
      kIdx = -1;
    }
    function run() {
      var q = input.value;
      if (q === lastQ && box.classList.contains('on')) return;
      lastQ = q; render(q); open();
      if (!items) load().then(function () { if (input.value === q) { lastQ = null; run(); } });
    }

    /* نوقف البحث القديم ونشغّل الجديد (بنمسك الأحداث قبل ما توصل للثيم) */
    ['input', 'keyup', 'focus', 'focusin', 'click', 'change'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        if (e.target !== input) return;
        e.stopImmediatePropagation();
        if (ev === 'input') { clearTimeout(timer); timer = setTimeout(run, 50); }
        else if (ev === 'focus' || (ev === 'click' && !box.classList.contains('on'))) { load(); lastQ = null; run(); }
      }, true);
    });
    input.addEventListener('pointerenter', function () { load(); }, { once: true });
    input.addEventListener('keydown', function (e) {
      var opts = box.querySelectorAll('.sx__it');
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!opts.length) return; e.preventDefault();
        kIdx = (kIdx + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length;
        opts.forEach(function (o, i) { o.classList.toggle('is-k', i === kIdx); }); opts[kIdx].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter') {
        if (kIdx > -1 && opts[kIdx]) { e.preventDefault(); remember(input.value); location.href = opts[kIdx].href; }
        else remember(input.value);
      } else if (e.key === 'Escape') { close(); input.blur(); }
    }, true);
    form.addEventListener('submit', function () { remember(input.value); });
    box.addEventListener('mousedown', function (e) { if (!e.target.closest('a')) e.preventDefault(); });
    box.addEventListener('click', function (e) {
      var c = e.target.closest('[data-q]'); if (c) { e.preventDefault(); input.value = c.getAttribute('data-q'); expanded = false; lastQ = null; run(); input.focus(); return; }
      if (e.target.closest('[data-clear]')) { ls(REC, '[]'); lastQ = null; renderEmpty(); return; }
      if (e.target.closest('[data-more]')) { expanded = true; lastQ = null; render(input.value); box.querySelector('.sx__in').scrollTop = 0; return; }
      var a = e.target.closest('.sx__it'); if (a) remember(input.value);
    });
    box.addEventListener('pointerover', function (e) {
      var a = e.target.closest('.sx__it'); if (!a || a.__pf) return; a.__pf = 1;
      var l = document.createElement('link'); l.rel = 'prefetch'; l.href = a.href; document.head.appendChild(l);
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    window.addEventListener('resize', place);
  }

  function boot() {
    if (!document.getElementById('sx-css')) { var s = document.createElement('style'); s.id = 'sx-css'; s.textContent = css; document.head.appendChild(s); }
    document.querySelectorAll('form[action$="/search"], form.smsm-search-form').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  /* نجهّز الفهرس في الخلفية بعد ما الصفحة تخلص تحميل عشان البحث يبقى فوري */
  window.addEventListener('load', function () { var go = function () { load(); }; setTimeout(function () { if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 4000 }); else go(); }, 2500); });
  window.SMSMSEARCH = { load: load, search: search, parse: parse, norm: norm, toks: toks, complete: complete, didYouMean: didYouMean };
})();
